import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { ListResponse } from 'src/common/utils/api';

type ParticipantRole = 'USER' | 'CLIENT' | 'EXTERNAL';

export type ExplorerParticipant = {
  attendanceId: string | null;
  participantId: string | null;
  clientId: string | null;
  userId: string | null;
  firstName: string | null;
  lastName: string | null;
  name: string | null;
  emailAddress: string | null;
  role: ParticipantRole;
  isDeleted: boolean;
  addedInAfternoon: boolean;
};

export type ExplorerEvent = {
  id: string;
  title: string;
  scheduledStartAt: string;
  scheduledEndAt: string;
  isDeleted: boolean;
  recallEventId: string | null;
  icalUid: string | null;
  createdAt: string;
  hasRecording: boolean;
  calendarId: string;
  calendarEmail: string | null;
  calendarIsDeleted: boolean | null;
  ownerUserId: string | null;
  ownerFirstName: string | null;
  ownerLastName: string | null;
  ownerEmailAddress: string | null;
  participants: ExplorerParticipant[];
};

export type ExplorerFilters = {
  calendarId?: string;
  calendarEmail?: string;
  ownerUserId?: string;
  clientId?: string;
  clientEmail?: string;
  clientFirstName?: string;
  clientLastName?: string;
  attendeeEmail?: string;
  title?: string;
  scheduledFrom?: string;
  scheduledTo?: string;
};

export const PAGE_SIZE = 50;

export const useMeetingsExplorer = (companyId: string, filters: ExplorerFilters, page: number) => {
  const params = {
    calendar_id: filters.calendarId,
    calendar_email: filters.calendarEmail,
    owner_user_id: filters.ownerUserId,
    client_id: filters.clientId,
    client_email: filters.clientEmail,
    client_first_name: filters.clientFirstName,
    client_last_name: filters.clientLastName,
    attendee_email: filters.attendeeEmail,
    title: filters.title,
    scheduled_from: filters.scheduledFrom,
    scheduled_to: filters.scheduledTo,
    page,
    size: PAGE_SIZE,
  };
  return useQuery<ListResponse<ExplorerEvent>>({
    queryKey: ['admin', 'companies', companyId, 'calendar-events', params],
    placeholderData: keepPreviousData,
  });
};
